export function randomElement(array) {
    if (!Array.isArray(array) || array.length < 1) {
        return null;
    }
    return array[Math.floor(Math.random() * array.length)];
}
export function shuffle(array) {
    return array.map(value => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
}
